










































































































import { Vue, Component } from 'vue-property-decorator';
import * as api from '@/api';
import { PaginationMixin } from '@/utils/mixin';
import { State } from 'vuex-class';

import TemplatePermissionDialog from './components/template-permission-dialog.vue';

import VueClipboards from 'vue-clipboards';

import axios from 'axios';
Vue.use(VueClipboards);

/**
 * rg模板列表
 *
 * @author xiaokunyu
 * @date 03/28/2019
 */
@Component({
    components: {
        TemplatePermissionDialog
    }
})
export default class RgTemplate extends PaginationMixin {
    @State(state => state.cti.permission.rg_template)
    permission: boolean;

    @State(state => state.cti.env)
    env: string;

    templateList: any = [];
    templatePermissionVisible: boolean = false;
    currentTemplate: any = 0;

    rgId: number = 0;
    tableLoading: Boolean = true;
    $mtd: any;

    templateId: number = 0;
    hoverContent: string = '';
    formlink: string = '';

    mounted() {
        this.rgId = parseInt(this.$route.query.rgId as string, 10);
        this.getRgCustomTemplate();
        this.formlink = `${this.getBaseURL}/ticket/helpdesk/${this.rgId}`;
    }

    get getBaseURL() {
        return this.env === 'prod' ? 'https://tt.sankuai.com' : 'http://tt.cloud.test.sankuai.com';
    }

    async getRgCustomTemplate() {
        this.tableLoading = true;
        try {
            const res = await api.rgApi.getRgCustomTemplate({
                cn: this.currentPage,
                sn: this.limit,
                rgId: this.rgId
            });
            const { code, data } = res;
            if (code === 200) {
                this.templateList = data.items;
                this.total = data.tn;
                if (this.total > 0 && !data.items.length) {
                    this.currentPage -= 1;
                    if (this.currentPage <= 0) {
                        this.currentPage = 1;
                    }
                    this.getRgCustomTemplate();
                }
                this.templateList = data.items;
            }
        } catch (e) {
            this.templateList = [];
            console.log(e);
        }
        this.tableLoading = false;
    }
    handleGoToSettingPage() {
        this.$router
            .push({
                name: 'rg_template_announcement',
                query: {
                    ...this.$route.query
                }
            })
            .catch(e => e);
    }
    handleChange(current: number, size: number) {
        this.limit = size;
        this.currentPage = current;
        this.getRgCustomTemplate();
    }
    // 复制rg模板
    async handleCopyTemplate(row: any) {
        if (!this.permission) return;
        const data = await this.getCustomFormDetail(row.id);
        await api.rgApi.addRgCustomTemplate({
            name: data.name + '-副本',
            instruction: data.instruction + `${data.name}的副本`,
            // permissionOrgs: data.permissionOrgs,
            customFieldContents: data.customFieldContents,
            rgId: this.rgId,
            type: '定制表单'
        });
        this.$mtd.message.success('模板复制成功');
        this.getRgCustomTemplate();
    }
    handleCopyLink(row) {
        // todo
        return row.copyLink;
    }
    onCopy() {
        return this.formlink;
    }
    handleCopySuccess() {
        if (!this.permission) return;
        this.$mtd.message.success('复制成功');
    }
    // 获取模板content
    async getCustomFormDetail(id) {
        const res = await api.rgApi.getCustomFormDetail(id, true);
        const { data } = res;
        return data;
    }
    // 编辑rg模板
    handleEditTemplate(id: number) {
        if (!this.permission) return;

        this.$router
            .push({
                name: 'custom-form',
                query: {
                    rgId: `${this.rgId}`,
                    formId: `${id}`
                }
            })
            .catch(e => e);
    }
    // 删除rg模板
    handleDeleteTemplate(id: number) {
        if (!this.permission) return;

        this.$mtd
            .confirm({
                title: '你是否确认删除该模板？',
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '删除',
                okButtonProps: {
                    type: 'danger'
                },
                onOk: async () => {
                    try {
                        await api.rgApi.deleteRgCustomTemplate(id);
                        this.$mtd.message({
                            message: '删除成功',
                            type: 'success'
                        });
                        await this.getRgCustomTemplate();
                    } catch (e) {
                        console.log(e);
                    }
                }
            })
            .catch(e => e);
    }
    async customFormDownloadMode(row) {
        if (!this.permission) return;

        const res = await api.ticketApi.customFormDownloadMode({
            customFormId: row.id
        });
        const { code, data } = res;
        if (code === 200) {
            if (data.sync) {
                this.handleExportTemplate(row);
            } else {
                this.$mtd.message.success(data.message);
            }
        }
    }

    handleExportTemplate(row) {
        if (!this.permission) return;

        axios({
            url: '/api/tt/1.0/file/download/by/custom/form',
            method: 'GET',
            responseType: 'blob',
            params: {
                customFormId: row.id
            }
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `模板“${row.name}”数据下载.xlsx`);
                document.body.appendChild(link);
                link.click();
            })
            .catch(e => {
                console.log(e);
            });
    }
    handleAddCustomTemplate() {
        if (!this.permission) return;
        this.$router
            .push({
                name: 'custom-form',
                query: {
                    rgId: `${this.rgId}`
                }
            })
            .catch(e => e);
    }
    handleSetPermission(row) {
        if (!this.permission) return;
        this.currentTemplate = row;
        this.templatePermissionVisible = true;
    }
    formatOrgs(permissionOrgs) {
        const orgs = permissionOrgs.map(item => {
            return item.orgPath;
        });
        return orgs.join('、');
    }
}
